import Wisteria1 from '../Wisteria/Wisteria (1).webp'
import Wisteria2 from '../Wisteria/Wisteria (2).webp'


const Wisteriaimages =[
Wisteria1,Wisteria2
]

export default Wisteriaimages;